import { Auth0Provider } from "@auth0/auth0-react";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { DriftThemeProvider } from "drift-ui";
import { createRoot } from "react-dom/client";
import ErrorBoundary from "./components/ErrorBoundary";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { createTheme, ThemeProvider } from "@mui/material/styles";

// Create a client
const queryClient = new QueryClient();

// // Create custom theme with proxima-nova font
const theme = createTheme({
  typography: {
    fontFamily: '"proxima-nova", "Roboto", "Helvetica", "Arial", sans-serif',
  },
});

const container = document.getElementById("root");
if (!container) {
  throw new Error("Failed to find the root element");
}
const root = createRoot(container);

root.render(
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_CUSTOM_DOMAIN!} //login domain 'auth.rtspro.dev', should be the same for all teams regardless of application
    clientId={process.env.REACT_APP_AUTH0_CLIENT_ID!} //clientId of the application specified above
    authorizationParams={{
      redirect_uri: window.location.origin, //location of your app rtspro.dev
      audience: `https://${process.env.REACT_APP_AUTH0_DOMAIN}/api/v2/`, // management api url 'https://stc-development.us.auth0.com/api/v2/'
      scope: "openid profile email offline_access",
    }}
  >
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <ThemeProvider theme={theme}>
        <DriftThemeProvider>
          <Router>
            <QueryClientProvider client={queryClient}>
              <ErrorBoundary>
                <App />
              </ErrorBoundary>
            </QueryClientProvider>
          </Router>
        </DriftThemeProvider>
      </ThemeProvider>
    </LocalizationProvider>
  </Auth0Provider>,
);
